module.exports = __webpack_public_path__ + "static/media/80748-square-loading-animation.c949d57c.gif";